import ConfirmRejectAlert from "components/ConfirmRejectAlert";
import { useState } from "react";
import { useT } from "i18n";
import "./styles.scss";

interface RejectScanButtonProps {
  onSubmit: (message: string) => void;
}

export default function RejectScanButton({ onSubmit }: RejectScanButtonProps) {
  const t = useT();
  const [isConfirmScanRejectModalOpen, setIsConfirmScanRejectModalOpen] =
    useState(false);

  const handleConfirm = (message: string) => {
    onSubmit(message);
    setIsConfirmScanRejectModalOpen(false);
  };

  return (
    <>
      <ConfirmRejectAlert
        description={t(
          "component.rejectScanButton.confirmRejectDescription",
          "Unfortunately the project submitted is missing key information required to generate a quote and complete the project. Please start a new project and rescan the pool capturing the following missing details:",
        )}
        isOpen={isConfirmScanRejectModalOpen}
        onClose={() => {
          setIsConfirmScanRejectModalOpen(false);
        }}
        onConfirm={handleConfirm}
      />
      <button
        className={"reject-scan-button"}
        onClick={() => {
          setIsConfirmScanRejectModalOpen(true);
        }}
      >
        {t("component.rejectScanButton.rejectScan", "Reject Scan")}
      </button>
    </>
  );
}
